import { Button } from "@hybrid-iptv/ui";
import { MAX_SHIFT_MINUTES, SHIFT_STEP_MINUTES, shiftLabel } from "./guideMapStore.js";

/**
 * A guide time shift, moved a quarter hour at a time (Phase 3 step 4): Earlier,
 * the value, Later. The value is text, never focusable, so the two buttons sit
 * side by side for Left and Right. Never disabled at the ends (12 hours): a
 * button switched off under the ring would drop focus. `note` says where an
 * unset value comes from.
 */
export function ShiftStepper({
  minutes,
  onChange,
  note,
  label = "Time shift",
}: {
  minutes: number;
  onChange: (minutes: number) => void;
  note?: string;
  label?: string;
}) {
  return (
    <div className="shift-stepper">
      <span className="shift-stepper__label">{label}</span>
      <Button
        variant="ghost"
        aria-label={`${label}: ${SHIFT_STEP_MINUTES} minutes earlier`}
        onClick={() => onChange(Math.max(-MAX_SHIFT_MINUTES, minutes - SHIFT_STEP_MINUTES))}
      >
        − Earlier
      </Button>
      <span className="shift-stepper__value" aria-live="polite">
        {shiftLabel(minutes)}
        {note ? <span className="shift-stepper__note"> {note}</span> : null}
      </span>
      <Button
        variant="ghost"
        aria-label={`${label}: ${SHIFT_STEP_MINUTES} minutes later`}
        onClick={() => onChange(Math.min(MAX_SHIFT_MINUTES, minutes + SHIFT_STEP_MINUTES))}
      >
        Later +
      </Button>
    </div>
  );
}
